import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { SimplebarAngularModule } from 'simplebar-angular';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SelectModule } from 'primeng/select';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';

import { LayoutComponent } from './layout.component';
import { FooterComponent } from './footer/footer.component';
import { HorizontalComponent } from './horizontal/horizontal.component';
import { HorizontaltopbarComponent } from './horizontaltopbar/horizontaltopbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { VerticalComponent } from './vertical/vertical.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { RightsidebarComponent } from './rightsidebar/rightsidebar.component';
import { LanguageService } from '../core/services/language.service';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    RouterModule,
    BsDropdownModule,
    SimplebarAngularModule,
    SelectModule,
    ToastModule,
    LayoutComponent,
    FooterComponent,
    HorizontalComponent,
    HorizontaltopbarComponent,
    SidebarComponent,
    TopbarComponent,
    VerticalComponent,
    BreadcrumbComponent,
    RightsidebarComponent
  ],
  exports: [
    LayoutComponent,
    FooterComponent,
    HorizontalComponent,
    HorizontaltopbarComponent,
    SidebarComponent,
    TopbarComponent,
    VerticalComponent,
    BreadcrumbComponent,
    RightsidebarComponent
  ],
  providers: [LanguageService]
})
export class LayoutsModule { }
